<template>
  <table class="table" style="width: 100%; margin: auto;">
    <thead>
      <tr>
        <th style="width: 5%">Board</th>
        <th style="width: 30%">
          <div class="is-flex is-align-items-center">
            <span class="image is-32x32">
              <img :src="'KING_WHITE' | chessPieceSvg" alt="" />
            </span>
            <span>&nbsp;White Player</span>
          </div>
        </th>
        <th style="width: 30%;">
          <div class="is-flex is-align-items-center">
            <span class="image is-32x32">
              <img :src="'KING_BLACK' | chessPieceSvg" alt="" />
            </span>
            <span>&nbsp;Black Player</span>
          </div>
        </th>
        <th style="width: 10%">Time &nbsp;&nbsp;&nbsp;</th>
        <th style="width: 15%">Status</th>
      </tr>
    </thead>
    <tbody>
      <tr
        v-for="game in games"
        :key="game.gameId"
        :class="{
          even: game.board % 2,
        }"
      >
        <td style="width: 5%">
          <router-link
            v-if="game.matchRef"
            :to="getTournamentGameUrl(tournamentId, game.matchGUID)"
            :class="game.finishTime ? 'has-text-warning' : 'has-text-success'"
          >
            {{ game.board }}
          </router-link>
          <span v-else>{{ game.board }}</span>
        </td>
        <td style="width: 30%">
          <div class="is-flex is-justify-content-space-between">
            <ProfileCard
              :player="getUserProfile(game.whiteUsername)"
              color="white"
            />
            <div>
              <GameResult :gameResult="game.whiteResult" />
              <b-tooltip label="Score before game" v-if="game.roundNumber > 1">
                {{ scoreBeforeGame(game.whiteUsername, game) }}
              </b-tooltip>
            </div>
          </div>
        </td>
        <td style="width: 30%">
          <div class="is-flex is-justify-content-space-between">
            <ProfileCard
              v-if="game.blackUsername"
              :player="getUserProfile(game.blackUsername)"
              color="white"
            />
            <div>
              <GameResult :gameResult="game.blackResult" />
              <b-tooltip label="Score before game" v-if="game.roundNumber > 1">
                {{ scoreBeforeGame(game.blackUsername, game) }}
              </b-tooltip>
            </div>
          </div>
        </td>
        <td style="width: 10%">
          {{ game.startTime | asTime }} -
          <p>{{ game.finishTime | asTime }}&nbsp;&nbsp;</p>
        </td>
        <td style="width: 15%">
          <router-link
            v-if="game.matchRef"
            :to="getTournamentGameUrl(tournamentId, game.matchGUID)"
            :class="game.finishTime ? 'has-text-warning' : 'has-text-success'"
          >
            <p>
              <b>{{ game | scoreText }}</b>
            </p>
            <p>
              <i>{{ game | resultText }}</i>
            </p>
          </router-link>
          <div v-else>
            <p>
              <b>{{ game | scoreText }}</b>
            </p>
            <p>
              <i>{{ game | resultText }}</i>
            </p>
          </div>
        </td>
        <!-- <td style="width: 10%">
          <button
            class="button is-small is-fullwidth is-primary"
            v-if="game.finishTime"
            @click="$emit('onReplayMatch', game.matchGUID)"
          >
            Watch Replay
          </button>
          <button
            class="button is-small is-fullwidth is-success"
            v-else-if="game.startTime && !game.finishTime"
            @click="$emit('onViewMatch', game.matchGUID)"
          >
            View Match
          </button>
          <button
            class="button is-small is-fullwidth is-danger"
            v-else-if="isMyCurrentGame(game)"
            @click="$emit('onPlayMatch', game.matchGUID)"
          >
            Play Match
          </button>
        </td> -->
      </tr>
    </tbody>
  </table>
</template>

<script>
import { TOURNAMENT_GAME_RESULT } from "vue-chess-shared/constants";
import ProfileCard from "@/components/players/ProfileCard.vue";
import GameResult from "@/components/games/GameResult.vue";
import GameHelper from "@/utils/game-helper";
import { mapGetters } from "vuex";
import gameUrls from "@/mixins/gameUrls";

export default {
  name: "RoundGameTable",
  components: {
    ProfileCard,
    GameResult,
  },

  mixins: [gameUrls],

  props: ["tournamentId", "round", "games", "players", "currentRoundNumber"],

  data() {
    return {
      standings: null,
    };
  },

  computed: {
    ...mapGetters(["getPlayer"]),
  },

  filters: {
    scoreText(game) {
      if (game.whiteResult === TOURNAMENT_GAME_RESULT.PAIRINGBYE) return 1;
      const match = game.matchRef;
      if (!match) return "";
      return match.player_1_score != null && match.player_2_score != null
        ? GameHelper.scoreText(match.player_1_score, match.player_2_score)
        : match.status
        ? match.status.toUpperCase()
        : "";
    },

    resultText(game) {
      if (game.whiteResult === TOURNAMENT_GAME_RESULT.PAIRINGBYE) {
        return "pairing bye";
      }
      const match = game.matchRef;
      if (!match) return "";
      return match.status === "finished" ||
        (match.player_1_score + match.player_2_score && match.result)
        ? match.result
        : "";
    },
  },

  methods: {
    isMine(game) {
      if (!this.getPlayer || !game) return false;
      return (
        this.getPlayer.username === game.whiteUsername ||
        this.getPlayer.username === game.blackUsername
      );
    },

    isMyCurrentGame(game) {
      return (
        this.isMine(game) &&
        !game.finishTime &&
        game.roundNumber === this.currentRoundNumber &&
        game.whiteResult === TOURNAMENT_GAME_RESULT.UNFINISHED
      );
    },

    getUserProfile(username) {
      if (!this.players || !this.players.length) return {};
      const player = this.players.find((p) => p.username === username);
      if (player && player.user) return player.user;
      return {};
    },

    scoreBeforeGame(username, game) {
      if (this.round && this.round.standings) {
        const standing = this.round.standings.find((s) => s.id === username);
        return standing ? standing.wins : null;
      }
      if (game.whiteUsername === username) return game.whiteScoreBeforeGame;
      if (game.blackUsername === username) return game.blackScoreBeforeGame;
      return null;
    },
  },
};
</script>

<style scoped>
table tbody {
  display: block;
  height: 80vh;
  overflow-y: scroll;
}

table thead,
table tbody tr {
  display: table;
  width: 100%;
  table-layout: fixed;
}

th {
  background-color: #5d095d;
  color: white !important;
  vertical-align: middle !important;
  height: 3rem;
}

td {
  vertical-align: middle !important;
}

tr {
  background-color: #573e97;
  color: white;
}

.even {
  background-color: #740074;
  color: white;
}

.table.is-striped tbody tr:not(.is-selected):nth-child(even) {
  background-color: #573e97;
  color: white;
}
</style>
